<template>
    <div>
        <h1 class="mb-4 font-active">Lifetime Trade-In and Upgrade Service</h1>
        <p>
            At Friendly Diamonds, we prioritise your satisfaction, and we are dedicated to building features that can help us further enhance your shopping experience. To add an extra layer of joy to your purchases, we present the <b>Lifetime Trade-In and Upgrade Service.</b>
        </p>

        <h2>Understanding Trade-In and Upgrades for Your Jewellery</h2>
        
        <p>Thinking of upgrading your old jewellery item? With every purchase made on our website, we offer Friendly Credits equivalent to the original purchase price of the jewellery. If you wish to trade your old Friendly Diamonds product, you can use these credits to acquire brand new pieces from our collection.</p><br>

        <p>Please note that the new product needs to be double the credit value received by you for your original product. This initiative aims to ensure that your experience with us is smooth and more rewarding as you add to your collection.</p>
        

        <h2>How It Works? A Step-by-Step Guide</h2>
        <p>If you wish to trade-in your product for any reason, whether you've changed your preferences or simply seek something new, you can easily do so by following three simple steps.</p>
        <br>
        <ol>
            <li>Contact our Customer Service Team at <a rel="nofollow noopener" :href="'mailto:'+$country.email">{{$country.email}}</a> to return the old product that you are ready to trade-in, ensuring it is in its original condition with intact packaging.</li>
            <li>The product will then pass a thorough quality check by our team. Once the returned product passes the check, a credit of the full value of the original purchase price will be initiated for the user.</li>
            <li>This credit can be further used by you to upgrade to new pieces in exchange for the former product from our collection.</li>
        </ol>

        <h4>Please note:</h4>
        <ul>
            <li>Only Friendly Diamonds’ original products qualify for our trade-in service.</li>
            <li>The credits for the new item must be redeemed by the customer within 7 days of receiving them.</li>
            <li>When considering an upgrade, customers are kindly requested to select only one new item using the upgrade value as multiple products cannot be purchased for the upgrade.</li>
            <li>Shipping charges for the return of the product to our Mumbai office will be the customer's responsibility. The replacement product will ship for free from our end.</li>
            <li>Kindly ensure to include the diamond or jewellery certificate with your product, whichever applicable. Failure to include the certificate will result in a deduction of ₹2,500 from the value.</li>
            <li>Each item can only be upgraded once. Once an item is upgraded, it is not eligible for upgrades or returns in the future.</li>
            <li>Any custom-built bespoke items and gift cards do not qualify for a trade-in and are non-exchangeable.</li>
            <li>Only items that have not been previously fixed or mended by anyone other than Friendly Diamonds qualify for exchange. Any alterations by a different jeweller will void the exchange and warranty.</li>
            <li>The final decision for the trade-in policy rests at the discretion of the Friendly Diamonds team, which includes factors like quality check assessment and order value.</li>
        </ul>
    </div>
</template>

<script setup>
    const { $country } = useNuxtApp()
</script>

<style scoped>
.main_title {
    margin: 4% 0;
}
.main_title h2 {
    font-size: 40px;
    text-align: center;
}
h1{
    font-size: 32px;
    text-transform: capitalize;
}
p {
    margin-bottom: 0;
    color: #606060;
    font-size: 16px;
    font-weight: 500;
}
ul {
    margin-left: 25px;
    padding-left: 0;
}
ul li{
    color: #606060;
    font-size: 16px;
    font-weight: 500; 
}
h3, h2 {
    font-size: 21px;
    font-weight: 500;
    margin: 30px 0 20px;
}
h4{
    margin-bottom: 6px;
    color: #353535;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
}
a{
    color: var(--green);
    text-decoration: underline;
}
ol {
    margin-left: 25px;
    padding-left: 0;
}
ol li{
    color: #606060;
    font-size: 16px;
    font-weight: 500;
}


@media(max-width: 767px){
    .main_title h2{
        font-size: 32px;
    }
    .main_title {
        margin: 13% 0 10%;
    }
    h1{
        font-size: 20px;
    }
    h3, h2{
        font-size: 18px;
    }

    p{
        font-size: 14px;
    }

    ol li {
        font-size: 14px;
    }

    ul li {
        font-size: 14px;
    }
}
</style>